export const themeNotFoundMessage = '@clds/component-theme: Unable to find theme in the context.' +
    ' Wrap your application with <ThemeProvider theme={generateTheme(…)}>.' +
    ' Or if you are in the tests, use <TestThemeWrapper> instead.';
//# sourceMappingURL=themeNotFoundMessage.js.map